const SECRET_CODE_CONFIG = {
  maxSequence: 5,
}

const SECRET_CODE_TYPE = {
  Konami: "KONAMI",
}

const SECRET_CODES_CONFIG = {
  // M O R T Y (5 keys) — focus the keyboard, then type MORTY to unlock the mousepad reveal
  // (these are internal key ids from keys-config.js, not browser keyCodes)
  // key ids: M=70, O=42, R=37, T=38, Y=39
  [SECRET_CODE_TYPE.Konami]: [70, 42, 37, 38, 39],
}

export { SECRET_CODE_CONFIG, SECRET_CODE_TYPE, SECRET_CODES_CONFIG };
